// Impressum.jsx
import React from 'react'
import { Helmet } from 'react-helmet-async'
import businessInfo from '../businessInfo'

function Impressum() {
  return (
    <>
      <Helmet>
        <title>Impressum | Payroll Expert</title>
        <meta name="description" content="Impressum von Payroll Expert. Kontakt- und Unternehmensinformationen gemäß § 5 TMG." />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-20 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
        <h1 className="text-4xl font-black text-gray-900 mb-12 text-center border-b-4 border-blue-600 pb-8">
          Impressum
        </h1>

        <div className="space-y-8 text-lg leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-blue-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="grid md:grid-cols-2 gap-8 p-6 bg-gray-50 rounded-xl">
              <div>
                <p><strong>{businessInfo.name}</strong></p>
                <p>{businessInfo.address.street}</p>
                <p>{businessInfo.address.zip} {businessInfo.address.city}</p>
                <p>{businessInfo.address.country}</p>
              </div>
              <div>
                <p><strong>Kontakt:</strong></p>
                <p>E-Mail: <a href="mailto:natalia@payroll-experten.de" className="text-blue-600 hover:underline">natalia@payroll-experten.de</a></p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-blue-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="p-6 bg-gray-50 rounded-xl">
              <p>{businessInfo.name}</p>
              <p>{businessInfo.address.street}</p>
              <p>{businessInfo.address.zip} {businessInfo.address.city}</p>
              <p>{businessInfo.address.country}</p>
            </div>
          </section>

          <section className="pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-blue-900 mb-4">Haftungsausschluss</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-bold">Haftung für Inhalte</h3>
                <p className="text-gray-700">
                  Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
                </p>
              </div>
              <div>
                <h3 className="font-bold">Haftung für Links</h3>
                <p className="text-gray-700">
                  Diese Website enthält ggf. Links zu externen Websites Dritter. Auf deren Inhalte habe ich keinen Einfluss. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      </div>
    </>
  )
}

export default Impressum
